import Point from "../types/Point";
import Spot, { SPOT_UNIT } from "../types/Spot";

export default function alignToGrid(point: Point): Point {
  return {
    x: Math.round(point.x / SPOT_UNIT) * SPOT_UNIT,
    y: Math.round(point.y / SPOT_UNIT) * SPOT_UNIT,
  };
}
